import React from 'react';
import { Stack, Text, Button } from '@moda/om';

import './ModaNetworkSuccessMessage.scss';

type Props = { onClose: () => void };

export const ModaNetworkSuccessMessage: React.FC<Props> = ({ onClose }) => {
  return (
    <Stack space={5}>
      <Stack space={4}>
        <Text className="ModaNetworkSuccessMessage__title" treatment="h3" family="serif">
          We’ve Received Your Inquiry
        </Text>
        <Text className="ModaNetworkSuccessMessage__description">
          MODA Network will review your information and get back to you shortly.
        </Text>
      </Stack>
      <Button className="ModaNetworkSuccessMessage__button" onClick={onClose}>
        Done
      </Button>
    </Stack>
  );
};
